import React from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { zIndex } from '../global/globals';

const fadeIn = keyframes`
	0% { opacity: 0 }
	100% { opacity: 1 }
`;

const StyledLoadingOverlay = styled.div`
	position: fixed;
	top: 0;
	right: 0;
	left: 0;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100vh;
	opacity: 0;
	animation: ${fadeIn} 500ms linear forwards;
	animation-delay: ${props => props.theme.routeTransitions.exitDuration}ms;
	background-color: #fff;
	z-index: ${zIndex.loader};
`;

const RawLoader = () => (
	<StyledLoadingOverlay name="loading">
		<img src="/assets/images/klukka.gif" alt="loader" rel="preload" />
	</StyledLoadingOverlay>
);

const Loading = ({ loading }) => (
	loading && (
		<RawLoader />
	)
);


const mapStateToProps = ({ pageReducer }) => {
	return {
		loading: pageReducer.loading
	};
};

export default connect(mapStateToProps)(Loading);
export { RawLoader };
